var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96606 1.13L2.23706 6.927L7.92906 5.341",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.237 6.92699C3.47619 4.53978 5.54709 2.68931 8.05815 1.72546C10.5692 0.761609 13.3464 0.75118 15.8646 1.69614C18.3828 2.64111 20.4676 4.47597 21.7247 6.85381C22.9817 9.23166 23.3241 11.9877 22.6869 14.6008C22.0497 17.2139 20.4772 19.503 18.2666 21.0353C16.0561 22.5676 13.3608 23.2369 10.6902 22.9167C8.01965 22.5964 5.55899 21.3088 3.77345 19.2972C1.98791 17.2857 1.00124 14.6897 1 12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3.9998V19.9998H11V3.9998H13Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6353 6.0176C13.3831 5.91051 15.3881 6.30068 16.4389 6.81401L17.3374 7.25294L16.4596 9.04998L15.561 8.61104C14.8776 8.27718 13.2295 7.92367 11.7576 8.01385C11.0264 8.05865 10.4634 8.20721 10.1141 8.42139C9.8219 8.60053 9.69366 8.80415 9.69366 9.14174C9.69366 9.59401 9.87948 9.88888 10.3234 10.178C10.8307 10.5084 11.5525 10.7424 12.4464 11.007C12.5087 11.0254 12.572 11.0441 12.6363 11.063C13.416 11.2924 14.3272 11.5605 15.0441 11.9708C15.8753 12.4466 16.6314 13.2245 16.6314 14.4818C16.6314 15.5296 16.2322 16.3799 15.521 16.9771C14.8488 17.5415 13.9783 17.8136 13.1185 17.9281C11.4013 18.1569 9.33547 17.8088 7.69452 17.2824L6.74231 16.9769L7.35322 15.0725L8.30542 15.378C9.78648 15.8531 11.5363 16.1212 12.8544 15.9457C13.5122 15.858 13.9641 15.6728 14.235 15.4454C14.4668 15.2507 14.6314 14.9745 14.6314 14.4818C14.6314 14.1987 14.5202 13.9754 14.0506 13.7066C13.5463 13.418 12.8518 13.2126 11.9852 12.9562C11.95 12.9458 11.9145 12.9353 11.8787 12.9247C11.0382 12.6759 10.0255 12.3708 9.23193 11.8539C8.37506 11.2958 7.69366 10.4354 7.69366 9.14174C7.69366 8.02106 8.26194 7.21098 9.06871 6.71634C9.81834 6.25674 10.7568 6.07143 11.6353 6.0176Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuHistory);
export default __webpack_public_path__ + "static/media/icon_menu_history.c63939ae.svg";
export { ForwardRef as ReactComponent };